<template>
  <div class="audit_container">
    <div class="navbar">
      <span> 场地预定</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div>
    <div class="audit_content d-f fxd-c ai-c">
      <img src="@/assets/images/detail/audit.png" alt="" class="audit_img" />
      <div class="title">正在审核</div>
      <div class="msg">预计审核时间：24小时内，审接结果会以短信形式告知，请您耐心等待</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'audit',
  data() {
    return {}
  },
  methods: {
    back() {
      this.$router.go(-2)
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.audit_container {
  width: 100%;
  height: 100vh;
  background: #fff;
  .navbar {
    z-index: 10;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .audit_content {
    padding: 0 0.6rem;
    padding-top: 3.3rem;
    width: 100%;
    // height: calc(100% - 44px - env(safe-area-inset-top));
    height: calc(100% - 84px);

    position: absolute;
    // top: calc(44px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    overflow-y: auto;
    padding-bottom: calc(3rem + env(safe-area-inset-bottom));
    .audit_img {
      width: 12rem;
      height: 10.65rem;
    }
    .title {
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
    .msg {
      margin-top: 0.4rem;
      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      text-align: center;
    }
  }
}
</style>
